import Home_ from './components/home';

export const Home = Home_;
